import { render, staticRenderFns } from "./SmartCaptcha.vue?vue&type=template&id=43ef3e32&scoped=true&"
import script from "./SmartCaptcha.vue?vue&type=script&lang=js&"
export * from "./SmartCaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ef3e32",
  null
  
)

export default component.exports